import * as React from "react";
import { Tennis as Scoreboard, Possession } from "sb-resp-ui";
import { EventText, LiveIndicator, EventCell, TimeStamp } from "..";
import { Icon } from "sb-resp-ui";
import { EventTextTypeModifiers, EventInformationObject, EventNameObj } from "../../../../data";
import { returnValueHelper, getValueHelper } from "../../../../helpers";

export function EventInfoSingleItemOrMobileView(eventObj: EventInformationObject) {
    let EventNameEachWay = returnValueHelper(!!eventObj.market.eachWayText, `${eventObj.event.eventName} ${eventObj.market.eachWayText}`, eventObj.event.eventName)
    let eventNameObj1: EventNameObj = {
        eventObj,
        onService: returnValueHelper(eventObj.onService === "1", true, false),
        timeStampMdf: eventObj.modifierDatePeriodTimes,
        textTimeScoreText: eventObj.textDatePeriodTime,
        eventTextTypeMdf: returnValueHelper(!!eventObj.pickedEvent.IsOutright, EventTextTypeModifiers.modifierEachWayEventName, EventTextTypeModifiers.modifierEventName),
        eventText: returnValueHelper(!!eventObj.pickedEvent.IsOutright, EventNameEachWay, eventObj.event.eventName)
    };
    let eventNameObj2: EventNameObj = {
        eventObj,
        onService: returnValueHelper(eventObj.onService === "2", true, false),
        timeStampMdf: eventObj.modifierTimeScore,
        textTimeScoreText: eventObj.textTimeScore,
        eventTextTypeMdf: returnValueHelper(!!eventObj.pickedEvent.IsOutright, EventTextTypeModifiers.modifierEachWay, EventTextTypeModifiers.modifierTeamName),
        eventText: returnValueHelper(!!eventObj.pickedEvent.IsOutright, eventObj.market.eachWayText, eventObj.event.team2Name)
    };
    let eventHasStartedLiveScb = eventObj.eventHasStarted && eventObj.hasLiveScb;
    return (
        <>
            {getValueHelper(eventObj.isMobileView && !eventObj.pickedEvent.IsOutright,
                <div className="rj-superbanner__event-names-row rj-superbanner__event-names-row--league-timestamp">
                    <div className="rj-superbanner__timestamp-cell">
                        {getValueHelper(!eventHasStartedLiveScb, <TimeStamp
                            modifier={eventNameObj1.timeStampMdf}
                            text={eventNameObj1.textTimeScoreText} />)}
                        <div className="rj-superbaner__icon ">
                            {getValueHelper(eventObj.event.isLive, <LiveIndicator liveText={eventObj.liveIndicatorText} />)}
                            {getValueHelper(eventObj.pickedEvent.HasLivestream, <Icon i={"i-24-16 new i-o-ev-streaming rj-superbaner__icon-live-stream "} />)}
                        </div>
                    </div>
                    <EventText text={eventObj.event.leagueName} modifier={[EventTextTypeModifiers.modifierLeague]} />
                </div>)}
            {getValueHelper(!eventObj.isMobileView,
                <>
                    <div className="rj-superbanner__event-names-row">
                        <div className="rj-superbanner__timestamp-cell">
                            {getValueHelper(!eventHasStartedLiveScb, <TimeStamp
                                modifier={eventNameObj1.timeStampMdf}
                                text={eventNameObj1.textTimeScoreText} />)}
                        </div>
                        <EventText text={eventObj.event.leagueName} modifier={[EventTextTypeModifiers.modifierLeague]} />
                    </div>
                    {getValueHelper(eventObj.pickedEvent.IsOutright,
                        getValueHelper(!eventHasStartedLiveScb, <TimeStamp
                            modifier={eventNameObj2.timeStampMdf}
                            text={eventNameObj2.textTimeScoreText} />)
                    )}
                </>
            )}
            <EventCell modifier={getValueHelper(eventHasStartedLiveScb, "scoreboard")}>
                {getValueHelper(eventHasStartedLiveScb, <Scoreboard {...eventObj.scoreboarProps} />)}
                <div className={"rj-superbanner__event-names-row" +
                    (returnValueHelper(eventHasStartedLiveScb, " rj-superbanner__event-names-row--scoreboard", ""))}>
                    {getValueHelper(eventObj.hasPossession,
                        <Possession
                            onService={eventNameObj1.onService}
                            modifier="superbanner" />)}
                    {getValueHelper(!eventObj.pickedEvent.IsOutright && !eventHasStartedLiveScb,
                        <TimeStamp
                            modifier={eventNameObj2.timeStampMdf}
                            text={eventNameObj2.textTimeScoreText} />)}
                    {returnValueHelper(eventHasStartedLiveScb,
                        <EventText text={eventObj.event.team1Name} modifier={["possession", EventTextTypeModifiers.modifierTeamName]} />,
                        <EventText
                            text={eventNameObj1.eventText}
                            modifier={
                                returnValueHelper(eventNameObj1.eventObj.eventTextMdf === "",
                                    [eventNameObj1.eventTextTypeMdf],
                                    [eventNameObj1.eventObj.eventTextMdf, eventNameObj1.eventTextTypeMdf])
                            } />)}
                </div>
                {getValueHelper(!eventObj.pickedEvent.IsOutright && eventHasStartedLiveScb,
                    <div className={"rj-superbanner__event-names-row" +
                        (returnValueHelper(eventHasStartedLiveScb, " rj-superbanner__event-names-row--scoreboard", ""))}>
                        {getValueHelper(eventObj.hasPossession,
                            <Possession
                                onService={eventNameObj2.onService}
                                modifier="superbanner" />)}
                        {getValueHelper(!eventObj.hasLiveScb,
                            <TimeStamp
                                modifier={eventNameObj2.timeStampMdf}
                                text={eventNameObj2.textTimeScoreText} />)}
                        {getValueHelper(eventHasStartedLiveScb,
                            <EventText text={eventObj.event.team2Name} modifier={["possession", EventTextTypeModifiers.modifierTeamName]} />)}
                    </div>)}
            </EventCell>
        </>
    )
}